module.exports = __webpack_public_path__ + "static/media/Postales-03.7400d485.png";